import {NameError, StandardLibraryContext, Value} from "formula-engine";

export type VariableLookupFunction = (name: string) => Value | null;

export class FormulaContext extends StandardLibraryContext {
  func: VariableLookupFunction | null;

  constructor(func: VariableLookupFunction | null) {
    super();
    this.func = func;
  }

  hasVariable(name: string): boolean {
    return super.hasVariable(name) || (this.func && this.func(name) !== null);
  }

  getVariable(name: string): Value {
    if (super.hasVariable(name)) {
      return super.getVariable(name);
    }
    if (this.func) {
      const value = this.func(name);
      if (value) {
        return value;
      }
    }
    throw new NameError();
  }
}
